<template>
  <div>
    <div>
      <div class="mb-3">
        <v-card class="grid_line_first" elevation="0" >
          <!-- loading_receipt_report -->
          <div>
            <div v-if="loading_receipt_report === true">
              <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
              </v-sheet>
            </div>
            <div v-else class="grid_three">
              <div class="ma-2">
                <v-card elevation="6">
                  <div class="pa-3">
                    <div><b>จำนวนสินค้าใกล้หมดอายุ</b></div>
                    <div class="grid_count mt-2">
                      <div class="mx-auto">
                        <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_expired" :src="img_expired"/>
                      </div>
                      <div class="pt-1 pl-5" style="font-size: 26px"><b>{{ format_number(product_expireds) }}</b></div>
                    </div>
                  </div>
                </v-card>
              </div>
              <div class="ma-2">
                <v-card elevation="6">
                  <div class="pa-3">
                    <div><b>รายการสินค้า Low Stock</b></div>
                    <div class="grid_count mt-2">
                      <div class="mx-auto">
                        <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_low_stock" :src="img_low_stock"/>
                      </div>
                      <div class="pt-1 pl-5" style="font-size: 26px"><b>{{ format_number(low_stock) }}</b></div>
                    </div>
                  </div>
                </v-card>
              </div>
              <div class="ma-2">
                <v-card elevation="6">
                  <div class="pa-3">
                    <div><b>จำนวน CN ที่รอรับคืน</b></div>
                    <div class="grid_count mt-2">
                      <div class="mx-auto">
                        <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_cn_refund" :src="img_cn_refund"/>
                      </div>
                      <div class="pt-1 pl-5" style="font-size: 26px"><b>{{ format_number(cn) }}</b></div>
                    </div>
                  </div>
                </v-card>
              </div>
              <div class="ma-2">
                <v-card elevation="6">
                  <div class="pa-3">
                    <div><b>รายการโปรโมชั่นสินค้าใกล้หมดอายุ</b></div>
                    <div class="grid_count mt-2">
                      <div class="mx-auto">
                        <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_promotion_set" :src="img_promotion_set"/>
                      </div>
                      <div class="pt-1 pl-5" style="font-size: 26px"><b>{{ format_number(promotion_expireds) }}</b></div>
                    </div>
                  </div>
                </v-card>
              </div>
              <div class="ma-2">
                <v-card elevation="6">
                  <div class="pa-3">
                    <div><b>จำนวนสินค้าจัดชุด</b></div>
                    <div class="grid_count mt-2">
                      <div class="mx-auto">
                        <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_product_set" :src="img_product_set"/>
                      </div>
                      <div class="pt-1 pl-5" style="font-size: 26px"><b>{{ format_number(promotion_mains) }}</b></div>
                    </div>
                  </div>
                </v-card>
              </div>
             <div class="ma-2">
               <v-card elevation="6">
                 <div class="pa-3">
                   <div><b>รายการโปรโมชั่นชุดคละ</b></div>
                   <div class="grid_count mt-2">
                     <div class="mx-auto">
                       <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_random_set" :src="img_random_set"/>
                     </div>
                     <div class="pt-1 pl-5" style="font-size: 26px"><b>{{ format_number(promotion_sets) }}</b></div>
                   </div>
                 </div>
               </v-card>
             </div>
            </div>
          </div>
          <!-- loading_stock_report -->
          <div>
            <div v-if="loading_stock_report === true">
              <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
              </v-sheet>
            </div>
            <div v-else class="ma-2">
              <v-card elevation="6">
                <div class="pa-3">
                  <div class="grid_header">
                    <div class="mx-auto">
                      <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_stock_list" :src="img_stock_list"/>
                    </div>
                    <div class="pt-2 pl-2" style="font-size: 28px"><b>รายการคลัง</b></div>
                  </div>
                </div>
                <div class="pa-3" style="margin-top: 18px !important">
                  <div class="grid_three_stock">
                    <div>
                      <div class="grey--text">คลังหลัก</div>
                      <div style="font-size: 26px"><b>{{ format_number(mains) }}</b></div>
                    </div>
                    <div>
                      <div class="grey--text">คลังใกล้หมดอายุ</div>
                      <div style="font-size: 26px"><b>{{ format_number(expireds) }}</b></div>
                    </div>
                    <div>
                      <div class="grey--text">คลังชำรุด</div>
                      <div style="font-size: 26px"><b>{{ format_number(damages) }}</b></div>
                    </div>
                    <div>
                      <div class="grey--text">คลังรอคืน</div>
                      <div style="font-size: 26px"><b>{{ format_number(returns) }}</b></div>
                    </div>
                    <div>
                      <div class="grey--text">คลังรอลดหนี้</div>
                      <div style="font-size: 26px"><b>{{ format_number(reducts) }}</b></div>
                    </div>
                    <div>
                      <div class="grey--text">คลังทิ้ง</div>
                      <div style="font-size: 26px"><b>{{ format_number(dumps) }}</b></div>
                    </div>
                  </div>
                </div>
              </v-card>
            </div>
          </div>
        </v-card>
      </div>
      <div class="mb-5">
        <v-card class="grid_line_second" elevation="0">
          <!-- loading_product_report -->
          <div>
            <v-card elevation="6" class="ma-2">
              <div class="pa-3">
                <div class="grid_header_product">
                  <div class="mx-auto">
                    <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_product_list" :src="img_product_list"/>
                  </div>
                  <div class="pt-2 pl-2" style="font-size: 26px"><b>รายการสินค้า</b></div>
                </div>
              </div>
              <div class="pa-3">
                <div class="d-flex justify-space-between mt-2 mb-8">
                  <router-link to="/stock/manage_product/productlist">
                    <div class="hover_text">รายการสินค้าปกติ</div>
                  </router-link>
                  <div>{{ format_number(product_set_price) }}</div>
                </div>
                <div class="d-flex justify-space-between mt-2 mb-8">
                  <router-link to="/stock/manage_product/productlowcost">
                    <div class="hover_text">รายการสินค้าราคาต่ำกว่าทุน</div>
                  </router-link>
                  <div>{{ format_number(product_low_cost) }}</div>
                </div>
                <div class="d-flex justify-space-between mt-2 mb-8">
                  <router-link to="/stock/manage_product/producthighcost">
                    <div class="hover_text">รายการสินค้าราคาสูงกว่าทุน</div>
                  </router-link>
                  <div>{{ format_number(product_high_cost) }}</div>
                </div>
                <div class="d-flex justify-space-between mt-2 mb-8">
                  <router-link to="/stock/manage_product/productnonprice">
                    <div class="hover_text">รายการสินค้าราคายังไม่ได้ตั้งราคา</div>
                  </router-link>
                  <div>{{ format_number(product_not_set_price) }}</div>
                </div>
                <div class="d-flex justify-space-between mt-2 mb-6">
                  <router-link to="/stock/manage_product/productclose">
                    <div class="hover_text">รายการสินค้าราคาที่ถูกปิด</div>
                  </router-link>
                  <div>{{ format_number(product_close) }}</div>
                </div>
              </div>
            </v-card>
            <v-card elevation="6" class="ma-2">
              <div class="pa-3">
                <div class="grid_header_product">
                  <div class="mx-auto">
                    <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_debit_card" :src="img_debit_card"/>
                  </div>
                  <div class="pt-2 pl-2" style="font-size: 26px"><b>การชำระค่าสินค้าประจำเดือน</b></div>
                </div>
                <div class="bill_payment_select">
                  <div class="grid_half">
                    <div class="ma-2">
                        <v-select color="#86bc3a" @input="dump_bill_payment_select()" :items="month" item-text="name" item-value="id" v-model="selected_month_bill_payment" prepend-inner-icon="mdi-calendar-month-outline" label="เดือน" hide-details="auto" outlined></v-select>
                    </div>
                    <div class="ma-2">
                        <v-select color="#86bc3a" @input="dump_bill_payment_select()" :items="year_arr" item-text="show_year" item-value="year_eng" v-model="selected_year_bill_payment" prepend-inner-icon="mdi-calendar-month-outline" label="ปี พ.ศ." hide-details="auto" outlined></v-select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="bill_payment_list">
                <div class="ma-3">
                  <div class="pa-3">
                      <div class="font_dairy"><b>ยอดเงินเครดิตที่จ่ายไป</b></div>
                      <div class="bill_payment_detail mt-2">
                        <div class="mx-auto">
                            <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_visa" :src="img_visa"/>
                        </div>
                        <div class="pt-2 pl-5" style="font-size: 26px"><b>{{ format_number(credit) }}</b></div>
                      </div>
                  </div>
                </div>
                <div class="ma-3">
                  <div class="pa-3">
                      <div class="font_dairy"><b>ยอดเงินสดที่จ่ายไป</b></div>
                      <div class="bill_payment_detail mt-2">
                        <div class="mx-auto">
                            <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_money_bag_report" :src="img_money_bag_report"/>
                        </div>
                        <div class="pt-2 pl-5" style="font-size: 26px"><b>{{ format_number(debit) }}</b></div>
                      </div>
                  </div>
                </div>
              </div>
            </v-card>
          </div>
          <!-- loading_dump_report -->
          <v-card elevation="6" class="ma-2">
            <div class="pa-3">
              <div class="grid_select">
                <div class="grid_header_drop">
                  <div class="mx-auto">
                    <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_product_drop" :src="img_product_drop"/>
                  </div>
                  <div class="pt-2 pl-2" style="font-size: 26px"><b>มูลค่าสินค้าทิ้งต่อเดือน</b></div>
                </div>
                <div class="">
                  <v-select color="#86bc3a" :items="year_arr" item-text="show_year" item-value="year_eng" v-model="selected_year" prepend-inner-icon="mdi-calendar-month-outline" label="ปี พ.ศ." @input="dump_data_select()" hide-details="auto" outlined></v-select>
                </div>
              </div>
            </div>
            <div class="pa-3">
              <canvas id="myChart"></canvas>
            </div>
          </v-card>
        </v-card>
      </div>
      <div class="grid_line_three">
        <!-- loading_quantity_report -->
        <div class="ma-2">
          <v-card elevation="6">
            <div class="pa-3">
              <div class="grid_header_quantity">
                <div class="mx-auto">
                  <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_product_tax_report" :src="img_product_tax_report"/>
                </div>
                <div class="pt-3 pl-4" style="font-size: 26px"><b>รายงานภาษีซื้อ</b></div>
              </div>
              <div class="grid_select_tax_report align-center">
                <div class="grid_half">
                  <div class="ma-2">
                      <v-select color="#86bc3a" @input="dump_tax_report_select()" :items="month" v-model="selected_month_tax_report" item-text="name" item-value="id" prepend-inner-icon="mdi-calendar-month-outline" label="เดือน" hide-details="auto" outlined></v-select>
                  </div>
                  <div class="ma-2">
                      <v-select color="#86bc3a" @input="dump_tax_report_select()" :items="year_arr" v-model="selected_year_tax_report" item-text="show_year" item-value="year_eng" prepend-inner-icon="mdi-calendar-month-outline" label="ปี พ.ศ." hide-details="auto" outlined></v-select>
                  </div>
                </div>
                <div class="grid_select_tax_report_excel">
                  <div class="ma-2">
                    <v-btn class="pa-6 grad-primary-bg white--text grid_select_tax_report_excel_button" @click="modal_excel_tax_report = true" style="font-size: 16px"><v-icon>mdi-microsoft-excel</v-icon> Export</v-btn>
                  </div>
                </div>
              </div>
              <v-card-title>
                <v-text-field v-model="search_tax_report" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
              </v-card-title>
              <v-data-table :headers="header_tax_report" :items="data_tax_report_list" key="index" item-key="product_code" :search="search_tax_report" mobile-breakpoint="0">
                <template slot="item" slot-scope="dataDetail">
                  <tr>
                    <td>{{ format_date(dataDetail.item.receipt_date) }}</td>
                    <td>{{ dataDetail.item.receipt_no }}</td>
                    <td>{{ dataDetail.item.name }}</td>
                    <td>{{ dataDetail.item.tax_number == null || dataDetail.item.tax_number == '' ? '-' : dataDetail.item.tax_number  }}</td>
                    <td>{{ dataDetail.item.office == null || dataDetail.item.office == '' ? '-' : dataDetail.item.office }}</td>
                    <td>{{ dataDetail.item.branch == null || dataDetail.item.branch == '' ? '-' : dataDetail.item.branch }}</td>
                    <td>{{ format_number(parseFloat(dataDetail.item.total_no_vat).toFixed(2)) }}</td>
                    <td>{{ format_number(parseFloat(dataDetail.item.vat).toFixed(2)) }}</td>
                    <td>{{ dataDetail.item.total == null || dataDetail.item.total == '' ? '-' : format_number(parseFloat(dataDetail.item.total).toFixed(2)) }}</td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </v-card>
        </div>
      </div>
      <v-dialog v-model="modal_excel_tax_report" max-width="400">
        <v-card>
          <v-form ref="add_form" @submit.prevent="">
            <v-card-title>
              เลือกชนิดไฟล์ดาวน์โหลด
            </v-card-title>
            <v-card-text>
              <div class="grid_full">
                <v-autocomplete clearable color="#86bc3a" :items="excel_type_tax_report_list" item-text="name" item-value="name" v-model="excel_type_tax_report_value" label="รายการ" prepend-inner-icon="mdi-archive" hide-details="auto" outlined></v-autocomplete>
              </div>
            </v-card-text>
            <v-spacer></v-spacer>
            <div class="text-center pa-4">
              <v-btn v-if="excel_type_tax_report_value !== null" large class="grad-success-bg white--text mr-3" type="button" style="font-size: 18px" @click="excelDownload()">ตกลง</v-btn>
              <v-btn v-else-if="excel_type_tax_report_value == null" large class="grad-grey-bg white--text mr-3" type="button" style="font-size: 18px" disabled>ตกลง</v-btn>
              <v-btn large class="grad-danger-bg white--text" type="button" style="font-size: 18px" @click="modal_excel_tax_report = false">ยกเลิก</v-btn>
            </div>
          </v-form>
        </v-card>
      </v-dialog>
      <div class="grid_line_three">
        <!-- loading_quantity_report -->
        <div class="ma-2">
          <v-card elevation="6">
            <div class="pa-3">
              <div class="grid_header_quantity">
                <div class="mx-auto">
                  <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_product_quantity" :src="img_product_quantity"/>
                </div>
                <div class="pt-3 pl-4" style="font-size: 26px"><b>จำนวนสินค้าคงเหลือ</b></div>
              </div>
              <v-card-title>
                <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
              </v-card-title>
              <v-data-table :headers="header" :items="data_list" key="index" item-key="product_code" :search="search" mobile-breakpoint="0" hide-default-footer>
                <template slot="item" slot-scope="dataDetail">
                  <tr>
                    <td>{{ dataDetail.item.product_code }}</td>
                    <td>{{ dataDetail.item.product_name }}</td>
                    <td>{{ dataDetail.item.product_name_sci }}</td>
                    <td>{{ format_number(dataDetail.item.mains) }}</td>
                    <td>{{ format_number(dataDetail.item.expireds) }}</td>
                    <td>{{ format_number(dataDetail.item.damages) }}</td>
                    <td>{{ format_number(dataDetail.item.returns) }}</td>
                    <td>{{ format_number(dataDetail.item.reducts) }}</td>
                    <td>{{ format_number(dataDetail.item.dumps) }}</td>
                    <td>{{ format_number(dataDetail.item.promotions) }}</td>
                    <td>{{ dataDetail.item.unit_name }}</td>
                  </tr>
                </template>
              </v-data-table>
            </div>
            <div class="text-center pa-2"><b class="hover_text" @click="continue_qty()">ดูสินค้าคงเหลือทั้งหมด</b></div>
          </v-card>
        </div>
        <v-overlay :value="overlay" class="z_index">
          <div class="text-center">
            <v-progress-circular
                indeterminate
                size="70"
                width="7"
                color="#86bc3a"
            ></v-progress-circular>
            <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
          </div>
        </v-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import img_expired from "@/assets/note_refund.png"
import img_low_stock from "@/assets/low_stock_report.png"
import img_cn_refund from "@/assets/refund_report.png"
import img_promotion_set from "@/assets/brand_positioning_report.png"
import img_product_set from "@/assets/packaging_report.png"
import img_random_set from "@/assets/boxes_random.png"
import img_stock_list from "@/assets/delivery_box_report.png"
import img_debit_card from "@/assets/debit-card.png";
import img_visa from "@/assets/debt.png";
import img_money_bag_report from "@/assets/money-bag-report.png";
import img_product_list from "@/assets/box_report.png"
import img_product_drop from "@/assets/low_report.png"
import img_product_tax_report from "@/assets/tax_report.png"
import img_product_quantity from "@/assets/packages_qty_report.png"
import {formatNumber} from "@/js/handler";
import Chart from 'chart.js/auto';
import * as XLSX from "xlsx";
import {HTTP} from "@/axios";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Warehouse_report",
  data() {
    return {
      overlay: false,
      img_expired: img_expired,
      img_low_stock: img_low_stock,
      img_cn_refund: img_cn_refund,
      img_promotion_set: img_promotion_set,
      img_product_set: img_product_set,
      img_random_set: img_random_set,
      img_stock_list: img_stock_list,
      img_debit_card:img_debit_card,
      img_visa:img_visa,
      img_money_bag_report:img_money_bag_report,
      img_product_list: img_product_list,
      img_product_drop: img_product_drop,
      img_product_tax_report: img_product_tax_report,
      img_product_quantity: img_product_quantity,
      console_chart: null,
      selected_year: null,
      selected_month_tax_report: null,
      selected_year_tax_report: null,
      search_tax_report: '',
      search: '',
      loading_receipt_report: false,
      loading_stock_report: false,
      loading_product_report: false,
      loading_dump_report: false,
      loading_quantity_report: false,
      myChart: null,
      year: 2022,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      product_expireds: 0,
      low_stock: 0,
      cn: 0,
      promotion_expireds: 0,
      promotion_mains: 0,
      promotion_sets: 0,
      mains: 0,
      expireds: 0,
      damages: 0,
      returns: 0,
      reducts: 0,
      dumps: 0,
      product_set_price: 0,
      product_low_cost: 0,
      product_high_cost: 0,
      product_not_set_price: 0,
      product_close: 0,
      selected_month_bill_payment: null,
      selected_year_bill_payment: null,
      credit: 0,
      debit: 0,
      month: [
          {id: 1, name: 'มกราคม'},
          {id: 2, name: 'กุมภาพันธ์'},
          {id: 3, name: 'มีนาคม'},
          {id: 4, name: 'เมษายน'},
          {id: 5, name: 'พฤษภาคม'},
          {id: 6, name: 'มิถุนายน'},
          {id: 7, name: 'กรกฎาคม'},
          {id: 8, name: 'สิงหาคม'},
          {id: 9, name: 'กันยายน'},
          {id: 10, name: 'ตุลาคม'},
          {id: 11, name: 'พฤศจิกายน'},
          {id: 12, name: 'ธันวาคม'},
      ],
      year_arr: [],
      excel_type_tax_report_list: [
        {id: 1, name: '.xls'},
        {id: 2, name: '.xlsx'},
      ],
      excel_type_tax_report_value: null,
      modal_excel_tax_report: false,
      header_tax_report: [
        {
          text: 'วัน-เดือน-ปี',
          value: 'receipt_date',
          fixed: true,
          width: '170px',
        },
        {
          text: 'เลขที่',
          value: 'receipt_no',
          fixed: true,
          width: '260px',
        },
        {
          text: 'ชื่อผู้ขาย/ผู้ให้บริการ',
          value: 'name',
          fixed: true,
          width: '200px',
        },
        {
          text: 'เลขประจำตัวผู้เสียภาษี',
          value: 'tax_number',
          fixed: true,
          width: '250px',
        },
        {
          text: 'สนญ',
          value: 'office',
          fixed: true,
          width: '180px',
        },
        {
          text: 'สาขา',
          value: 'branch',
          fixed: true,
          width: '180px',
        },
        {
          text: 'มูลค่าสินค้า',
          value: 'total_no_vat',
          fixed: true,
          width: '180px',
        },
        {
          text: 'ภาษีมูลค่าเพิ่ม',
          value: 'vat',
          fixed: true,
          width: '180px',
        },
        {
          text: 'รวมทั้งสิ้น',
          value: 'total',
          fixed: true,
          width: '180px',
        },
      ],
      data_tax_report_list: [],
      header: [
        {
          text: 'รหัสสินค้า',
          value: 'product_code',
          fixed: true,
          width: '170px',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'product_name',
          fixed: true,
          width: '260px',
        },
        {
          text: 'ชื่อทางวิทยาศาสตร์',
          value: 'product_name_sci',
          fixed: true,
          width: '200px',
        },
        {
          text: 'คลังหลัก',
          value: 'mains',
          fixed: true,
          width: '180px',
        },
        {
          text: 'คลังใกล้หมดอายุ',
          value: 'expireds',
          fixed: true,
          width: '180px',
        },
        {
          text: 'คลังชำรุด',
          value: 'damages',
          fixed: true,
          width: '180px',
        },
        {
          text: 'คลังรอคืน',
          value: 'returns',
          fixed: true,
          width: '180px',
        },
        {
          text: 'คลังรอลดหนี้',
          value: 'reducts',
          fixed: true,
          width: '180px',
        },
        {
          text: 'คลังทิ้ง',
          value: 'dumps',
          fixed: true,
          width: '180px',
        },
        {
          text: 'คลังโปรโมชั่น',
          value: 'promotions',
          fixed: true,
          width: '180px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit_name',
          fixed: true,
          width: '180px',
        },
      ],
      data_list: [],
      graph_list: [],
    }
  },
  methods: {
    format_date(date){
      let formatDate = date.split('-')
      return `${formatDate[2]}-${formatDate[1]}-${formatDate[0]}`
    },
    format_number: function (value) {
      return formatNumber(value)
    },
     async year_function() {
      this.year_arr = []
      let arr_year = [0, 1, 2]
      let count_year = new Date()
      let full_year = count_year.getFullYear()
      let month_selected = count_year.getMonth() + 1
      for (let i = 0; i < arr_year.length ; i++) {
        let count_th = ((full_year + 543) - i);
        let count_eng = ((full_year) - i);
        this.year_arr.push({
          id: i,
          year_th: count_th,
          year_eng: count_eng,
          show_year: 'ปี ' + count_th,
        })
      }
      this.selected_month_bill_payment = month_selected
      this.selected_year_bill_payment = this.year_arr[0].year_eng
      await this.dump_bill_payment_select()

      this.selected_year = this.year_arr[0].year_eng
      await this.dump_data_select()

      this.selected_month_tax_report = month_selected
      this.selected_year_tax_report = this.year_arr[0].year_eng
      await this.dump_tax_report_select()
    },
    async dump_bill_payment_select(){
      this.credit = 0
      this.debit = 0
      await HTTP.post('/inventory/dashboards/reportpay', {
          month: this.selected_month_bill_payment,
          year: this.selected_year_bill_payment
      }).then((res) => {
          if (res.data.success === true) {
              this.credit = res.data.credit
              this.debit = res.data.debit
          }
      })
    },
    async dump_data_select() {
      this.graph_list = []
      await HTTP.post('/inventory/dashboards/graph', {
        year: this.selected_year
      }).then((res) => {
        if (res.data.success === true) {
          res.data.object.forEach((data) => {
            this.graph_list.push(parseFloat(data.values))
          })
          if (this.myChart !== null) {
            this.myChart.destroy()
          }
          this.chart_bar()
        }
      })
    },
    async dump_tax_report_select(){
      this.data_tax_report_list = []
      await HTTP.post('/inventory/dashboards/reportbuytax', {
          month: this.selected_month_tax_report,
          year: this.selected_year_tax_report
      }).then((res) => {
          if (res.data.success === true) {
              this.data_tax_report_list = res.data.object
          }
      })
    },
    chart_bar() {
      let data = {
        labels: this.$store.state.monthThai,
        datasets: [
          {
            label: 'ยอดเงิน',
            data: this.graph_list,
            borderColor: '#2ab88b',
            backgroundColor: '#2ab88b',
            fill: false
          },
        ]
      }
      let config = {
        type: 'bar',
        data: data,
        options: {
          responsive: true
        }
      }
      let ctx = document.getElementById('myChart').getContext('2d');
      this.myChart = new Chart(ctx, config)
    },
    async get_data() {
      this.overlay = true
      await HTTP.post('/inventory/dashboards/amount')
          .then((res) => {
            if (res.data.success === true) {
              this.product_expireds = res.data.object.product_expireds
              this.low_stock = res.data.object.low_stock
              this.cn = res.data.object.cn
              this.promotion_expireds = res.data.object.promotion_expireds
              this.promotion_mains = res.data.object.promotion_mains
              if (res.data.object.promotion_sets) {
                this.promotion_sets = res.data.object.promotion_sets
              }
              this.mains = res.data.object.mains
              this.expireds = res.data.object.expireds
              this.damages = res.data.object.damages
              this.returns = res.data.object.returns
              this.reducts = res.data.object.reducts
              this.dumps = res.data.object.dumps
              this.product_set_price = res.data.object.product_set_price
              this.product_low_cost = res.data.object.product_low_cost
              this.product_high_cost = res.data.object.product_high_cost
              this.product_not_set_price = res.data.object.product_not_set_price
              this.product_close = res.data.object.product_close
            }
          })
    },
    async get_data_table() {
      await HTTP.post('/inventory/dashboards/productswarehouse', {
        limit: 0
      }).then((res) => {
        if (res.data.success === true) {
          this.overlay = false
          this.data_list = res.data.object
        }
      })
    },
    async excelDownload(){
      HTTP.post('/inventory/dashboards/reportbuytax', {
          month: this.selected_month_tax_report,
          year: this.selected_year_tax_report
      }).then((res) => {
          if (res.data.success === true) {
              let json = [{
                'วัน-เดือน-ปี': '',
                'เลขที่': '',
                'ชื่อผู้ขาย/ผู้ให้บริการ':'',
                'เลขประจำตัวผู้เสียภาษี': '',
                'สถานประกอบการ': 'สนญ',
                'สถานประกอบการ-สาขา': 'สาขา',
                'มูลค่าสินค้า': '',
                'ภาษีมูลค่าเพิ่ม': '',
                'รวมทั้งสิ้น': '',
              }]
              res.data.object.forEach((data) => {
                json.push({
                  'วัน-เดือน-ปี': this.format_date(data.receipt_date),
                  'เลขที่': data.receipt_no,
                  'ชื่อผู้ขาย/ผู้ให้บริการ': data.name,
                  'เลขประจำตัวผู้เสียภาษี': data.tax_number == null || data.tax_number == '' ? '-' : data.tax_number,
                  'สถานประกอบการ': data.office == null || data.office == '' ? '-' : data.office,
                  'สถานประกอบการ-สาขา': data.branch == null || data.branch == '' ? '-' : data.branch,
                  'มูลค่าสินค้า': this.format_number(parseFloat(data.total_no_vat).toFixed(2)),
                  'ภาษีมูลค่าเพิ่ม': this.format_number(parseFloat(data.vat).toFixed(2)),
                  'รวมทั้งสิ้น': data.total == null || data.total == '' ? '-' : this.format_number(parseFloat(data.total).toFixed(2)),
                })
              })
              const dataWS = XLSX.utils.json_to_sheet(json)

              const merge = [
                { 
                  s: { r: 0, c: 0 }, 
                  e: { r: 1, c: 0 } 
                },
                { 
                  s: { r: 0, c: 1 }, 
                  e: { r: 1, c: 1 } 
                },
                { 
                  s: { r: 0, c: 2 }, 
                  e: { r: 1, c: 2 } 
                },
                { 
                  s: { r: 0, c: 3 }, 
                  e: { r: 1, c: 3 } 
                },
                { 
                  s: { r: 0, c: 4 }, 
                  e: { r: 0, c: 5 } 
                },
                { 
                  s: { r: 0, c: 6 }, 
                  e: { r: 1, c: 6 } 
                },
                { 
                  s: { r: 0, c: 7 }, 
                  e: { r: 1, c: 7 } 
                },
                { 
                  s: { r: 0, c: 8 }, 
                  e: { r: 1, c: 8 } 
                },
              ];
              dataWS["!merges"] = merge;
              const ws_name = 'Sheet1'
              const wscols = [
                { wch: 15 },
                { wch: 30 },
                { wch: 20 },
                { wch: 15 },
                { wch: 12 },
                { wch: 15 },
                { wch: 12 },
                { wch: 13 },
                { wch: 13 },
              ];
              const wb = XLSX.utils.book_new()
              dataWS['!cols'] = wscols;
              XLSX.utils.book_append_sheet(wb, dataWS, ws_name)
              let year = this.year_arr.find((detail) => detail.year_eng == this.selected_year_tax_report);
              let month = this.month.find((detail) => detail.id == this.selected_month_tax_report);
              const result_date = 'เดือน_'+month.name +'_ปี_'+ year.year_th;
              XLSX.writeFile(wb,'รายงานภาษีซื้อ_'+ result_date + this.excel_type_tax_report_value)
              this.modal_excel_tax_report = false
            
          }
      })
  
    },
    continue_qty() {
      const id = 1
      this.$router.push('/warehousereport/warehousequantity/' + id)
    },
  },
  mounted() {
    this.year_function()
    this.get_data()
    this.get_data_table()
  }
}
</script>

<style scoped>
.grid_line_first {
  display: grid;
  grid-template-columns: 55% 45%;
  grid-gap: 15px 0;
}
.grid_three {
  display: grid;
  grid-template-columns: 33.33% 33.33% 33.33%;
  grid-gap: 15px 0;
}
.grid_three_stock {
  display: grid;
  grid-template-columns: 33.33% 33.33% 33.33%;
  grid-gap: 15px 0;
}
.grid_line_second {
  display: grid;
  grid-template-columns: 30% 70%;
  grid-gap: 15px 0;
}
.hover_text {
  cursor: pointer;
  color: black !important;
  transition: 0.1s;
}
.hover_text:hover {
  color: #8cc63e !important;
  transition: 0.1s;
}
.grid_count {
  display: grid;
  grid-template-columns: 25% 75%;
}
.grid_header {
  display: grid;
  grid-template-columns: 15% 85%;
}
.grid_header_product {
  display: grid;
  grid-template-columns: 20% 80%;
}
.grid_header_drop {
  display: grid;
  grid-template-columns: 10% 90%;
}
.grid_select {
  display: grid;
  grid-template-columns: 80% 20%;
}
.grid_header_quantity {
  display: grid;
  grid-template-columns: 5% 95%;
}

.bill_payment_select{
  width: 80%;
  margin-left: auto;
}

.bill_payment_detail{
  display: grid;
  grid-template-columns: 25% 75%;
}

.grid_select_tax_report{
  display: grid;
  grid-template-columns: 35% 65%;
}

.grid_select_tax_report_excel{
  text-align: right;
}
@media only screen and (max-width: 1180px) {
  .grid_line_first {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_header_product {
    display: grid;
    grid-template-columns: 10% 90%;
  }
  .grid_header_drop {
    display: grid;
    grid-template-columns: 13% 87%;
  }
  .grid_line_second {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_header_quantity {
    display: grid;
    grid-template-columns: 10% 90%;
  }
  .bill_payment_select{
    width: 100%;
    margin-left: unset;
  }
  .bill_payment_list{
    display: grid;
    grid-template-columns: 50% 50%;
  }
  .grid_select_tax_report{
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_select_tax_report_excel{
    text-align: unset;
    width: 100%;
  }
  .grid_select_tax_report_excel_button{
    width: 100%;
  }
}
@media only screen and (max-width: 500px) {
  .grid_three {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_line_second {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_header_product {
    display: grid;
    grid-template-columns: 25% 75%;
  }
  .grid_select {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_header_drop {
    display: grid;
    grid-template-columns: 25% 75%;
  }
  .grid_header_quantity {
    display: grid;
    grid-template-columns: 25% 75%;
  }
  .grid_header {
    display: grid;
    grid-template-columns: 30% 70%;
  }
  .grid_three_stock {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 15px 0;
  }
  .bill_payment_detail{
    display: grid;
    grid-template-columns: 50% 50%;
  }
}
</style>
